<div class="modal-header">
  <!-- Title -->
  <h4 *ngIf="currentView === 'newModel'" class="modal-title">
    {{ 'Manage Asset List' | translate }}
  </h4>
  <h4 *ngIf="currentView === 'all'" class="modal-title">
    {{ 'Existing Models' | translate }}
  </h4>
  <!-- Header actions -->
  <div class="header-actions">
    <button *ngIf="currentView === 'newModel'" type="button" class="btn import-model-btn" (click)="handleImportModel()">
      IMPORT MODEL
    </button>
    <button
      *ngIf="currentView === 'newModel'"
      type="button"
      [disabled]="isSaveNewModelDisabled"
      class="btn save-new-model-btn"
      (click)="handleSaveNewModel()">
      SAVE AS NEW MODEL
    </button>
    <button
      *ngIf="currentView === 'all'"
      type="button"
      class="btn back-to-new-model-btn"
      (click)="handleBackToNewModel()">
      BACK
    </button>
  </div>
</div>
<div class="modal-body model-asset-body">
  <!-- New Model View -->
  <ng-container *ngIf="currentView === 'newModel'">
    <div class="asset-actions d-flex justify-content-between">
      <div>
        <div class="asset-actions__model-name">
          <input type="text" placeholder="Model name" class="model-name-input" [(ngModel)]="newModelName" />
        </div>
        <div class="input-error" *ngIf="isExistedModelName">
          {{ 'modelNameExisted' | translate }}
        </div>
      </div>
    </div>

    <div class="asset-list-container" [ngClass]="{ disabled: !isEditing }">
      <mtm-asset-list
        [bundle]="newModelDisplayAssets"
        [originalBundle]="newModelAssets"
        [readOnly]="false"
        [workspaceId]="workspaceId"
        [hideFilter]="true"
        [showStatus]="true"
        [fromCampaignDashboard]="true"
        [campaignId]="campaignId"
        (assetsUpdated)="assetBundleUpdated($event)"
        (assetUpdated)="createUpdateAsset($event)"
        (assetDeleted)="deleteAsset($event)"
        (assetDeletedSubAsset)="deleteSubAsset($event.id, $event.subAssetId)"
        (assetBundleChange)="assetBundleChanged($event)"
        (bulkUpdateAssets)="bulkUpdateAssets($event)"
        class="w-100"></mtm-asset-list>
    </div>
  </ng-container>
  <!-- All Models View -->
  <ng-container *ngIf="currentView === 'all'">
    <ng-container *ngIf="models.length; else noModels">
      <div class="models-container">
        <div class="model-item" *ngFor="let model of models">
          <div class="model-header" (click)="toggleModel(model.id)">
            <div class="model-header-content">
              <i class="mtm-icon mtm-icon-right-triangle-black" [class.expanded]="expandedModels[model.id]"></i>
              <span class="model-name">{{ model.name }}</span>
            </div>
            <div *ngIf="expandedModels[model.id]" class="model-actions">
              <div
                class="tooltip-wrapper"
                (mouseenter)="showTooltipEdit = isRestrictedModel(model.name)"
                (mouseleave)="showTooltipEdit = false">
                <button
                  type="button"
                  class="btn edit-model-btn"
                  [disabled]="isRestrictedModel(model.name)"
                  (click)="handleEditModelClick(model.id, $event)">
                  EDIT
                </button>
                <div class="custom-tooltip" *ngIf="showTooltipEdit && isRestrictedModel(model.name)">
                  {{ 'useOnlyModels' | translate }}
                </div>
              </div>

              <div
                class="tooltip-wrapper"
                (mouseenter)="showTooltipDelet = isRestrictedModel(model.name)"
                (mouseleave)="showTooltipDelet = false">
                <button
                  type="button"
                  class="btn delete-model-btn"
                  [disabled]="isRestrictedModel(model.name)"
                  (click)="handleDeleteModelClick(model.id, $event)">
                  DELETE
                </button>
                <div class="custom-tooltip" *ngIf="showTooltipDelet && isRestrictedModel(model.name)">
                  {{ 'useOnlyModels' | translate }}
                </div>
              </div>
              <button type="button" class="btn use-model-btn" (click)="handleUseModel(model, $event)">
                USE THIS MODEL
              </button>
            </div>
          </div>
          <div class="model-content" [ngbCollapse]="!expandedModels[model.id]">
            <div class="asset-list-container" [class.disabled]="model.id !== editingModelId">
              <mtm-asset-list
                [bundle]="model.assets"
                [originalBundle]="model.assets"
                [readOnly]="true"
                [workspaceId]="workspaceId"
                [hideFilter]="true"
                [campaignId]="campaignId"
                [showStatus]="true"
                [fromCampaignDashboard]="true"
                (assetUpdated)="createUpdateAsset($event, model.id)"
                (assetDeleted)="deleteAsset($event, model.id)"
                (assetDeletedSubAsset)="deleteSubAsset($event, model.id)"
                (bulkUpdateAssets)="bulkUpdateAssets($event, model.id)"
                class="w-100">
              </mtm-asset-list>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #noModels>
      <div class="f-10 _400"> No existing model. </div>
    </ng-template>
  </ng-container>
</div>
<div class="modal-footer model-asset-footer">
  <ng-container *ngIf="currentView === 'newModel'">
    <ng-container *ngIf="!isEditing">
      <button type="button" class="btn cancel-btn" [disabled]="isLoading || isSavingTimeline" (click)="dismiss()">
        <span class="cancel-btn-text">CLOSE</span>
      </button>
      <button
        type="button"
        [disabled]="isLoading || isSavingTimeline"
        class="btn edit-btn"
        (click)="toggleEditNewModel()">
        EDIT
      </button>
    </ng-container>
    <ng-container *ngIf="isEditing">
      <button type="button" [disabled]="isLoading || isSavingTimeline" class="btn cancel-btn" (click)="onCancel()">
        <span class="cancel-btn-text">CANCEL</span>
      </button>
      <button type="button" [disabled]="isLoading || isSavingTimeline" class="btn save-btn" (click)="onSave()">
        SAVE
      </button>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="currentView === 'all'">
    <ng-container *ngIf="editingModelId">
      <button
        type="button"
        class="btn cancel-btn"
        [disabled]="isLoading || isSavingTimeline"
        (click)="editingModelId = ''">
        <span class="cancel-btn-text">CANCEL</span>
      </button>
      <button
        type="button"
        [disabled]="isLoading || isSavingTimeline"
        class="btn save-btn"
        (click)="editingModelId = ''">
        SAVE
      </button>
    </ng-container>
  </ng-container>
</div>
